module.exports = __webpack_public_path__ + "img/xsg.5c2697a1.svg";